import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import type { Alert } from '../../models/alert';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-alert',
  imports: [SharedModule],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  dialogRef = inject(MatDialogRef<AlertComponent>);
  dialogData = inject(MAT_DIALOG_DATA);

  data: Alert | null = null;
  type: string = '';
  imagePath: string | null = '';
  submitLabel: string | null = '';
  cancelLabel: string | null = '';

  ngOnInit(): void {
    this.type = this.dialogData.type;
    this.data = this.dialogData.data;
    this.submitLabel = this.dialogData.data.rightButton;
    this.cancelLabel = this.dialogData.data.leftButton;
    this.imagePath = this.dialogData.imagePath;

    this.dialogRef.backdropClick().subscribe(() => {
      this.onCancelClick();
    });
  }

  onSubmitClick(): void {
    this.dialogRef.close({ key: true });
  }

  onCancelClick(): void {
    this.dialogRef.close({ key: false });
  }

  onBtnSuccess(): void {
    this.dialogRef.close({ key: true });
  }
}
